import { render, staticRenderFns } from "./FrzChamberLosses.vue?vue&type=template&id=22582de3"
import script from "./FrzChamberLosses.vue?vue&type=script&lang=js"
export * from "./FrzChamberLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports